import HeroImg from "../components/HeroImg"
import Navbar from "../components/Navbar"
import Work from "../components/Work"

const Home = () => {

    return (
        <div>
            <Navbar />
            <HeroImg />
            <Work />
        </div>
    )

}

export default Home